import { useEffect } from 'react';
export function useResizeObserver(object, listener) {
  useEffect(() => {
    if (!object) return;
    const resizeObserver = new ResizeObserver((entries, observer) => listener(entries, observer));
    resizeObserver.observe(object);
    return () => resizeObserver.disconnect();
  }, [object, listener]);
}